import { styled } from "@mui/material";
import { rem } from "polished";
import React from "react";

import { type BasicBuildingFragment } from "src/graphql/generated/types";

const StyledContentEstate = styled("div")`
  border-left: ${rem(3)} solid ${(props) => props.theme.palette.primary.main};
  padding-left: ${(props) => props.theme.spacing(2)};
  font-weight: bold;
  background-color: ${(props) => props.theme.palette.common.white};

  ${(props) => props.theme.breakpoints.down("lg")} {
    padding: ${(props) => props.theme.spacing(2)};
  }
`;

const StyledParagraph = styled("p")`
  margin: 0;
`;

const StyledContentEstateTitle = styled(StyledParagraph)`
  color: ${(props) => props.theme.palette.secondary.main};
  font-size: ${rem(16)};
`;

const StyledContentEstateAddress = styled("div")`
  margin-top: ${(props) => props.theme.spacing(1)};
  color: ${(props) => props.theme.palette.gray.main};
  font-size: ${rem(13)};
`;

type Props = {
  buildings: Array<BasicBuildingFragment>;
};
export const ContentEstate = ({ buildings }: Props) => {
  return (
    <StyledContentEstate role="presentation">
      {buildings.length === 1 && (
        <>
          <StyledContentEstateTitle>{buildings[0].name}</StyledContentEstateTitle>
          <StyledContentEstateTitle>Immeuble {buildings[0].number}</StyledContentEstateTitle>
          <StyledContentEstateAddress role="presentation">
            <StyledParagraph>{buildings[0].address.address1}</StyledParagraph>
            <StyledParagraph>
              {[buildings[0].address.zipCode, buildings[0].address.city].filter((i) => i).join(" ")}
            </StyledParagraph>
          </StyledContentEstateAddress>
        </>
      )}

      {buildings.length > 1 && <div>{buildings.length} immeubles</div>}
    </StyledContentEstate>
  );
};
